<template>
  <div>
    <nav-bar></nav-bar>
    <div id="OurCertificates" class="container-fluid has-action-bar ">

      <div class="container-md min-height-body">
        <div class="row">
          <div class="col-12 text-center">
            <silent-box :gallery="gallery" class="p-5" ></silent-box>
          </div>
        </div>
      </div>
    </div>
    <footer-pages></footer-pages>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import FooterPages from "@/components/FooterPages";
export default {
  name: "OurCertificates",
  metaInfo: {
    title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-گواهی نامه ها'
  },
  components: {
    FooterPages,
    NavBar

  },
  data: () => ({
    title: "گواهی نامه ها",
    gallery: [
      {
        src: require('../assets/img/certificates/Iravani-MBA.jpg'),
        alt: 'iranani_MBA',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: require('../assets/img/certificates/Iravani-DBA.jpg'),
        alt: 'iravani-DBA',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },

      {
        src: require('../assets/img/certificates/Amani-MBA.jpg'),
        alt: 'amani-MBA',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: require('../assets/img/certificates/Amani-DBA.jpg'),
        alt: 'amani-DBA',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },

      {
        src: require('../assets/img/certificates/IZISYS.jpg'),
        alt: 'IZISYS',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: require('../assets/img/certificates/Iravani-Teacher-Certificate.jpg'),
        alt: 'iravani-teacher',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: require('../assets/img/certificates/Amani-Teacher-Certificate.jpg'),
        alt: 'teacher-Amani',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: require('../assets/img/certificates/iso.png'),
        alt: 'ISO9001',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },

    ]
  }),
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    }
    },
  mounted() {
    this.isokia = this.$getisokia();
    this.$setCssFiles();
  },

}
</script>

<style scoped>

</style>
